import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams } from '../types';
import META from './useTrackDepletedUpsellClicked.meta';

export type UseTrackDepletedUpsellClickedParams = CreditAnalyticsParams & {
  surface:
    | 'upload_modal'
    | 'canvas'
    | 'banner'
    | 'canvas_agent_chat'
    | 'meter_popover'
    | 'asset_edit'
    | 'workspace_agent';
};

export const useTrackDepletedUpsellClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackDepletedUpsellClicked = useCallback(
    (params: UseTrackDepletedUpsellClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackDepletedUpsellClicked };
};
